import { browserName, browserVersion, osName, isMobile } from 'mobile-device-detect'

export function checkBrowserSupport() {
  const browser = browserName.toLowerCase()
  const version = Number(browserVersion.split('.')[0])
  const os = osName.toLowerCase()

  const notSupportedDesktop = {
    chrome: { below: 61 },
    opera: { below: 48 },
    firefox: { below: 52 },
    safari: { below: 10 },
    edge: { below: 80 },
    yandex: { notSupported: true },
    ie: { notSupported: true },
  }

  const notSupportedMobile = {
    ios: { below: 11, ucbrowser: { notSupported: true } },
    android: { below: 4, ucbrowser: { notSupported: true } },
  }

  const rules = isMobile ? notSupportedMobile[os] : notSupportedDesktop[browser]

  if (!rules) return true
  if (rules.notSupported) return false
  if (rules.fullySupported) return true
  if (Number.isNaN(version)) return true
  if (rules.below != null && version < rules.below) return false
  if (rules[browser] && rules[browser].notSupported) return false
  return true
}
